module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "regionList"
  }, [_c('v-content', [(_vm.loaded == false) ? _c('center', [_c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../shared/assets/images/3dloader.gif")
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [(_vm.loaded == true) ? _c('div', {
    staticClass: "relative"
  }, [(_vm.search != '') ? _c('a', {
    staticClass: "searchTypeClear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncClearSearch.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons searchTypeClearText"
  }, [_vm._v("close")])]) : _vm._e(), _vm._v(" "), (_vm.search == '') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": _vm.fncCustomSearch
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.search != '') ? _c('v-text-field', {
    attrs: {
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": _vm.fncCustomSearch
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _c('br')], 1) : _vm._e()]), _vm._v(" "), (_vm.loaded == true) ? _c('v-data-table', {
    staticClass: "elevation-1 mainTable",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredSearch,
      "pagination": _vm.pagination,
      "expand": "",
      "rows-per-page-items": [1000]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [(props.item.display == true) ? _c('tr', [(props.expanded == true) ? _c('td', {
          attrs: {
            "width": "80%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [(props.item.children && props.item.children.length > 0) ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))]) : _c('td', {
          attrs: {
            "width": "80%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [(props.item.children && props.item.children.length > 0) ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1) ? _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditRegion(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]) : _vm._e()]) : _vm._e()]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-data-table', {
          staticClass: "elevation-1 subTable subTable1 minTable",
          attrs: {
            "search": _vm.search,
            "headers": _vm.headers,
            "items": props.item.children,
            "expand": "",
            "hide-actions": "",
            "rows-per-page-items": [10000000]
          },
          scopedSlots: _vm._u([{
            key: "items",
            fn: function(props) {
              return [_c('tr', [(props.expanded == true) ? _c('td', {
                staticClass: "levelone",
                attrs: {
                  "width": "80%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [(props.item.children && props.item.children.length > 0) ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))]) : _c('td', {
                staticClass: "levelone",
                attrs: {
                  "width": "80%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [(props.item.children && props.item.children.length > 0) ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1) ? _c('td', {
                attrs: {
                  "width": "20%"
                }
              }, [_c('a', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncEditRegion(props.item)
                  }
                }
              }, [_c('i', {
                staticClass: "material-icons"
              }, [_vm._v("edit")])])]) : _vm._e()])]
            }
          }, {
            key: "expand",
            fn: function(props) {
              return [_c('v-data-table', {
                staticClass: "elevation-1 subTable2 minTable",
                attrs: {
                  "search": _vm.search,
                  "headers": _vm.headers,
                  "items": props.item.children,
                  "expand": "",
                  "hide-actions": "",
                  "rows-per-page-items": [10000000]
                },
                scopedSlots: _vm._u([{
                  key: "items",
                  fn: function(props) {
                    return [_c('tr', [(props.expanded == true) ? _c('td', {
                      staticClass: "levelthree",
                      attrs: {
                        "width": "80%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [(props.item.children && props.item.children.length > 0) ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))]) : _c('td', {
                      staticClass: "levelthree",
                      attrs: {
                        "width": "80%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [(props.item.children && props.item.children.length > 0) ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1) ? _c('td', {
                      attrs: {
                        "width": "20%"
                      }
                    }, [_c('a', {
                      on: {
                        "click": function($event) {
                          $event.preventDefault();
                          return _vm.fncEditRegion(props.item)
                        }
                      }
                    }, [_c('i', {
                      staticClass: "material-icons"
                    }, [_vm._v("edit")])])]) : _vm._e()])]
                  }
                }, {
                  key: "expand",
                  fn: function(props) {
                    return [_c('v-data-table', {
                      staticClass: "elevation-1 subTable3 minTable",
                      attrs: {
                        "search": _vm.search,
                        "headers": _vm.headers,
                        "items": props.item.children,
                        "expand": "",
                        "hide-actions": "",
                        "rows-per-page-items": [10000000]
                      },
                      scopedSlots: _vm._u([{
                        key: "items",
                        fn: function(props) {
                          return [_c('tr', [(props.expanded == true) ? _c('td', {
                            staticClass: "levelfour",
                            attrs: {
                              "width": "80%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [(props.item.children && props.item.children.length > 0) ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))]) : _c('td', {
                            staticClass: "levelfour",
                            attrs: {
                              "width": "80%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [(props.item.children && props.item.children.length > 0) ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.name))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1) ? _c('td', {
                            attrs: {
                              "width": "20%"
                            }
                          }, [_c('a', {
                            on: {
                              "click": function($event) {
                                $event.preventDefault();
                                return _vm.fncEditRegion(props.item)
                              }
                            }
                          }, [_c('i', {
                            staticClass: "material-icons"
                          }, [_vm._v("edit")])])]) : _vm._e()])]
                        }
                      }], null, true)
                    })]
                  }
                }], null, true)
              })]
            }
          }], null, true)
        })]
      }
    }], null, false, 3666324787)
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}